import isAppointment from './adressHelpers/taskKind'

const recentAdressVisits = (tasks) => {
    if (!Array.isArray(tasks)) return []
    // isAppointment, niet Type: een subtaak met een datum is geen bezoek.
    // AI-CONTEXT: See docs/features/subtaken-bij-het-huishouden.md
    return tasks
        .filter(t => isAppointment(t) && t.Timestamp)
        .sort((a, b) => b.Timestamp.toDate() - a.Timestamp.toDate())
}

export default recentAdressVisits
